import { render } from "./TeacherView.vue?vue&type=template&id=40358f54&scoped=true"
import script from "./TeacherView.vue?vue&type=script&lang=js"
export * from "./TeacherView.vue?vue&type=script&lang=js"

import "./TeacherView.vue?vue&type=style&index=0&id=40358f54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40358f54"]])

export default __exports__